export default{
  srodowiska:[
    {
      id: 0,
      title: 'Okręg Wileński Polskiego Państwa Podziemnego',
      text: 'W roku 1970 Edward Gierek objął najwyższe stanowisko Władz partyjnych w Kraju i jednocześnie zostały bardzo złagodzone inwigilacje, aresztowania i represje stosowane przez Służby Bezpieczeństwa do żołnierzy Armii Krajowej Okręgu Wileńskiego',
      url: "/srodowiska/okreg_wilenski",
      img: '/srodowiska/okreg_wilenski.jpg'
    },
    {
      id: 1,
      title: 'Środowisko Wileńskie w Gdańsku',
      text: 'Po zarejestrowaniu w 1990 r. Światowego Związku Żołnierzy Armii Krajowej - jako samodzielnej organizacji kombatanckiej - ukształtowała się w Gdańsku jego komórka pod nazwą: "Środowisko Wileńskie w Gdańsku"',
      url: "/srodowiska/srod_gdansk",
      img: '/srodowiska/srod_gdansk.jpg'
    },
    {
      id: 2,
      title: 'Środowisko Wileńskie w Warszawie',
      text: 'W latach 1981-1983 kol. Ryszard Andrys-Jankowski w porozumieniu z Radą Starszych Okręgu Wileńskiego (organizacją nie formalną) rozpoczął starania u Władz Administracyjnych RP i w Zarządzie Głównym ZBoWiD zarejestrowania Klubu Żołnierzy Armii Krajowej',
      url: "/srodowiska/srod_warszawa",
      img: '/srodowiska/srod_warszawa.jpg'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/models/srodowiska.js